const dataChipPaddingDefault = 11;
const dataChipPaddingCompact = 8;

const dataChipFontSizeDefault = 15;
const dataChipFontSizeCompact = 12;

const thumbsMaxItems = 4;
const thumbsItemSize = {
    small: 14,
    medium: 28,
    large: 42,
};
const thumbsItemOffset = {
    small: 6,
    medium: 8,
    large: 12,
};

function getDataChipBasis(characters = 1, compact = false) {
    // This utility is to help derive a suitable
    // flex-basis for a <DataChip /> based on the
    // expected number of characters passed as `value`.

    const padding = compact ? dataChipPaddingCompact : dataChipPaddingDefault;
    const fontSize = compact ? dataChipFontSizeCompact : dataChipFontSizeDefault;

    return padding * 2 + fontSize * characters;
}

function getThumbsMaxWidth(count = thumbsMaxItems, size = 'small') {
    const minCount = Math.max(0, count);

    const sizePx = thumbsItemSize[size];
    const offsetPx = thumbsItemOffset[size];

    const totalOffset = minCount * offsetPx;
    // Add `1` for the <Pocket />.
    const preOffsetWidth = (minCount + 1) * sizePx;

    return preOffsetWidth - totalOffset;
}

export const tokens = {
    color: {
        black: {
            battleship: '#8a8e91',
            davy: '#565f64',
            coal: '#202323',
            eerie: '#161919',
            // Is this close enough to: `#161919`?
            void: '#181a1a',
        },
        brown: {
            sugar: '#c47253',
            sienna: '#772d18',
        },
        red: {
            china: '#a44a63',
            rojo: '#db1111',
        },
        pink: {
            dazzle: '#ff30d1',
        },
        orange: {
            peel: '#fd9e2a',
        },
        yellow: {
            satin: '#c99839',
            sunset: '#fbcf87',
        },
        green: {
            asparagus: '#77a44a',
            pear: '#e7ec2a',
        },
        blue: {
            alice: '#e1f2ff',
            sky: '#87d1fb',
            celestial: '#398dc9',
        },
        violet: {
            china: '#8f6479',
            claret: '#84092e',
        },
        indigo: {
            tropical: '#9b94d8',
            slate: '#6357d1',
            violet: '#4f45ad',
            midnight: '#332c78',
        },
        purple: {
            marian: '#3d4080',
            dark: '#22192e',
        },
    },
    leaderboard: {
        gap: 27,
    },
    row: {
        gap: 16,
        padding: {
            default: 28,
            compact: 10,
        },
    },
    column: {
        gap: 10,
        minWidth: 80,
        basis: {
            profitLoss: {
                default: getDataChipBasis(10),
                compact: getDataChipBasis(10, true),
            },
            usd: {
                default: getDataChipBasis(7),
                compact: getDataChipBasis(7, true),
            },
            quantity: {
                default: getDataChipBasis(3),
                compact: getDataChipBasis(3, true),
            },
            topPicks: getThumbsMaxWidth(),
        },
    },
    badge: {
        padding: 8,
        height: {
            default: 18,
            medium: 15,
            compact: 14,
        },
        fontSize: {
            default: 12,
            medium: 11,
            compact: 8,
        },
    },
    dataChip: {
        radius: 999,
        padding: {
            default: dataChipPaddingDefault,
            compact: dataChipPaddingCompact,
        },
        height: {
            default: 30,
            compact: 24,
        },
        fontSize: {
            default: dataChipFontSizeDefault,
            compact: dataChipFontSizeCompact,
        },
    },
    percent: {
        fontSize: {
            default: 12,
            compact: 10,
        },
    },
    rank: {
        padding: 12,
        height: 32,
        label: {
            fontSize: 12,
        },
    },
    header: {
        heading: {
            fontSize: 12,
        },
        sortAction: {
            gap: 4,
        },
    },
    list: {
        gap: 10,
    },
    item: {
        radius: 10,
        minHeight: {
            default: 68,
            compact: 48,
        },
    },
    credits: {
        gap: 4,
    },
    title: {
        fontSize: {
            default: 15,
            compact: 12,
        },
    },
    handle: {
        fontSize: {
            default: 13,
            compact: 10,
        },
    },
    status: {
        signal: 10,
        gap: {
            default: 12,
            compact: 12,
        },
        fontSize: {
            default: 15,
            compact: 12,
        },
    },
    thumbs: {
        zindex: {
            item: 1,
            mask: 2,
        },
        list: {
            maxItems: thumbsMaxItems,
        },
        item: {
            mask: {
                medium: 2,
                large: 4,
            },
            offset: thumbsItemOffset,
            radius: {
                medium: 9,
                large: 14,
            },
            size: thumbsItemSize,
        },
        pocket: {
            fontSize: {
                medium: 14,
                large: 18,
            },
        },
    },
    visitAnchor: {
        gap: 8,
    },
};
